import * as React from 'react';
import { Link } from 'react-router';
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import { Button } from '../General/Button';
import { Input } from '../General/Input';
import { FlexRowCenter } from '../../Defaults/Flexbox/Flexbox';
import { Loader } from '../General/Loader';

interface Props {
  onSendEmailClick: (e: string) => void;
  error: string | null;
  isFetching: boolean;
  emailSended: boolean;
}

function ForgotPasswordForm({
  error,
  isFetching,
  emailSended,
  onSendEmailClick,
}: Props) {
  const [email, setEmail] = React.useState('');

  const handleSendEmailClick = () => {
    onSendEmailClick(email);
  };

  return (
    <Wrapper>
      <Header>{`${__('Zabudnuté heslo')}`}</Header>
      <React.Fragment>
        {!emailSended ? (
          <div>
            {error ? <ErrorWrapper>{error}</ErrorWrapper> : ''}

            <EmailInput
              tabIndex={1}
              type="email"
              name="email"
              placeholder={__('Zadajte Váš email')}
              value={email}
              // tslint:disable-next-line:jsx-no-lambda
              onChange={e => setEmail(e.target.value)}
            />

            <SubmitButton
              disabled={isFetching || email.length === 0}
              tabIndex={2}
              onClick={handleSendEmailClick}
            >
              {isFetching ? (
                <FlexRowCenter>
                  {`${__('Odosielam')}...`}
                  <Loader className="marginLeft" small={true} />
                </FlexRowCenter>
              ) : (
                __('Odoslať')
              )}
            </SubmitButton>
          </div>
        ) : (
          <SuccessTextWrapper>
            {__('Email bol úspešne zaslaný')}
          </SuccessTextWrapper>
        )}

        <NoAccountWrapper>
          {emailSended ? (
            <LoginLink to={__('routes:prihlasenie')}>
              {__('Prihláste sa')}
            </LoginLink>
          ) : (
            <>
              {`${__('Nemáte účet')}? `}
              <SingUpLink to={__('routes:registracia')}>
                {__(' Vytvorte si ho')}
              </SingUpLink>
            </>
          )}
        </NoAccountWrapper>
      </React.Fragment>
    </Wrapper>
  );
}

const secondaryText = css`
  color: ${({ theme }) => theme.colors.textPrimary};
  text-decoration-color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.font.secondary};
  font-weight: 300;
  font-size: ${rem(14)};
  line-height: ${rem(22)};
`;

const Wrapper = styled.div`
  width: 100%;
  max-width: ${rem(320)};
  background: ${({ theme }) => theme.colors.white};
`;

const Header = styled.h1`
  font-size: ${rem(30)};
  font-weight: 400;
  position: relative;
  font-family: ${({ theme }) => theme.font.primary};
  margin-bottom: ${rem(32)};
  line-height: ${rem(38)};
  color: ${({ theme }) => theme.colors.textPrimary};
`;

const EmailInput = styled(Input)`
  width: 100%;
  margin-top: ${rem(30)};
`;

export const SubmitButton = styled(Button)`
  height: ${rem(48)};
  margin: ${rem(15)} 0 0;
  padding: ${rem(8)};
  width: 100%;
  max-width: ${rem(320)};
  background-color: ${({ theme }) => theme.colors.secondary};
  color: ${({ theme }) => theme.colors.black};
  font-size: ${rem(14)};
  border-radius: ${rem(2)};
  margin: ${rem(32)} 0;
  display: flex;
  justify-content: center;
  align-items: center;

  &:disabled {
    background-color: #dcd6d6;
    padding: 0;
  }
`;

const LoginLink = styled(Link)`
  height: ${rem(48)};
  margin: ${rem(15)} 0 0;
  padding: 0 ${rem(16)};
  width: 100%;
  max-width: ${rem(320)};
  background-color: ${({ theme }) => theme.colors.secondary};
  color: ${({ theme }) => theme.colors.black};
  font-size: ${rem(14)};
  border-radius: ${rem(2)};
  margin: ${rem(32)} 0;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
`;

const NoAccountWrapper = styled.span`
  ${secondaryText};
  display: flex;
  justify-content: center;
`;

const SingUpLink = styled(Link)`
  font-size: ${rem(14)};
  text-decoration: underline;
  ${secondaryText};
  display: inline-block;
  text-decoration: underline;
  margin: 0;
  margin-left: ${rem(4)};
`;

const ErrorWrapper = styled.div`
  color: red;
  margin-bottom: ${rem(15)};
`;

const SuccessTextWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  margin: ${rem(32)} 0;
  color: forestgreen;
  font-size: ${rem(18)};
`;

export { ForgotPasswordForm };
